var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useMdi)?_c('vs-icon',{class:{ 'avatar-icon-container': _vm.rounded },attrs:{"icon":_vm.icon,"color":_vm.color_x,"bg":_vm.backgroundColor_x,"size":_vm.size_x,"round":_vm.rounded}}):_c('feather-icon',_vm._g(_vm._b({class:{ 'avatar-icon-container': _vm.rounded },style:(_vm.styles)},'feather-icon',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }